import {HttpErrorResponse} from "@angular/common/http";
import {HttpResponskoder} from "../../infrastruktur/http/httpResponskoder";
import {i18n, I18nTekst} from "../i18n/Oversettelser";

/** Returnerer feilmeldingstekst for standard feilkoder.
 * Null dersom vi ikke har noen standard tekst for aktuell feilkode. */
export function standardFeilmeldingerForErrorRespons(errorRespons: HttpErrorResponse): I18nTekst | null {
    switch (errorRespons.status) {
      //tilgangskontroll-spesifikt
        case HttpResponskoder.IkkeTilgangTilEntitetException_møteIkkePublisert:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da møtet ikke er publisert'));
        case HttpResponskoder.IkkeTilgangTilEntitetException_protokollIkkePublisert:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da protokollen ikke er publisert'));
        case HttpResponskoder.IkkeTilgangTilEntitetException_skjermet:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da du ikke har tilgang til forespurt informasjon'));
        case HttpResponskoder.IkkeTilgangTilEntitetException_privat:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da du ikke er eier av forespurt informasjon'));
        case HttpResponskoder.IkkeTilgangTilEntitetException_gruppetilgang:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da du ikke har tilgang til aktuell gruppe'));
        case HttpResponskoder.IkkeTilgangTilEntitetException_ikkeSpesifisertÅrsak:
            return new I18nTekst(i18n('Operasjonen kan ikke utføres da du ikke har tilgang'));

      //dersom entitet ikke finnes i DB
        case HttpResponskoder.ObjectNotFoundException:
            return new I18nTekst(i18n('Forespurt informasjon har blitt slettet'));

        default:
            return null;
    }
}

/** Returnerer feilmeldingstekst for standard feilkoder. */
export function standardFeilmeldingerForErrorResponsMedFallback(errorRespons: HttpErrorResponse): I18nTekst {
    return standardFeilmeldingerForErrorRespons(errorRespons) ?? standardFallbackFeilmelding(errorRespons);
}

export function standardFallbackFeilmelding(feil: unknown): I18nTekst {
    return new I18nTekst(i18n('Operasjonen kunne ikke utføres, teknisk feilmelding: {melding}'), {melding: formatFeil(feil)});
}

function formatFeil(feil: unknown): string {
    if (feil instanceof Error) return feil.message;
    if (typeof feil === "string") return feil;
    try {
        return JSON.stringify(feil);
    } catch {
        return 'unknown';
    }
}
